module.exports = __webpack_public_path__ + "img/uploadExample.7ab4352b.png";